import React from "react";
import "./style.css";
import OutsideClick from "../commonComponents/OutsideClick";
type ModalProps = {
  onClose: () => void;
  children?: React.ReactNode;
  modalStyle?: {};
};

function Bg() {
  return (
    <div
      className="absolute backdrop-blur-[5px] backdrop-filter h-screen w-screen left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%] w-[1440px]"
      data-name="BG"
    >
      <div
        className="absolute bg-center bg-cover bg-no-repeat blur-md filter inset-0 opacity-[0.64]"
        data-name="98"
        // style={{ backgroundImage: `url('${img98}')` }}
      />
    </div>
  );
}

const Modal: React.FC<ModalProps> = (props) => {
  //   if (!isOpen) return null;

  return (
    <div
      className="fixed h-screen w-screen top-0 left-0 custom-modal"
      data-name="Create Workspace Modal"
    >
      <Bg />
      <OutsideClick
        handleClickOutside={() => {
          props.onClose();
        }}
      >
        <div
          className="absolute box-border content-stretch flex flex-row gap-2 h-screen items-end justify-start right-[0px] p-0 top-0 w-[512px]"
          style={props.modalStyle ? props.modalStyle : {}}
        >
          {props.children}
        </div>
      </OutsideClick>
    </div>
  );
};

export default Modal;
